import axios from 'axios';
import Handlers from './handlers'

const API_PATH = 'non-working-days/';

class NonWorkingDaysService {
    list(requestData) {
        const url = API_PATH + 'list';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
	createEdit(requestData) {
        const url =  API_PATH + 'create_edit';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    details(requestData) {
        const url = API_PATH + 'details';
        return new Promise((resolve, reject) => {
            axios.post(url, { id: requestData.id })
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
	delete(requestData) {
        const url = API_PATH + 'delete';
        return new Promise((resolve, reject) => {
            axios.post(url, requestData.id)
                .then(response => {
                    // handle success
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    // handle error
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
}

export default new NonWorkingDaysService();